const data = {
  data: {},
  processing: false,
  dirty: false,
  saved: false,
  saving: false
}

export default {
  namespaced: true,
  strict: process.env.NODE_ENV === 'development',
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Set the form data.
     *
     * @param {*} state
     * @param {*} data
     */
    setData (state, data) {
      state.data = data
    },

    /**
     * Set the dirty state of the form.
     * @param {*} state
     * @param {*} dirty
     */
    setDirty (state, dirty) {
      state.dirty = dirty
    },

    /**
     * Set the processing state of the form.
     *
     * @param {*} state
     * @param {*} processing
     */
    setProcessing (state, processing) {
      state.processing = processing
    },

    /**
     * Set the saved state of the form.
     *
     * @param {*} state
     * @param {*} saved
     */
    setSaved (state, saved) {
      state.saved = saved
    },

    /**
     * Set the saving state of the form.
     *
     * @param {*} state
     * @param {*} saving
     */
    setSaving (state, saving) {
      state.saving = saving
    },

    /**
     * Reset all state.
     * @param {*} state
     */
    reset (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    }
  }
}
